import React, { useEffect, useState } from "react";
import Bar from "./Bar";
import { observer } from "mobx-react";
import { displayUnit } from "../../utils/functions";

const BarChart = observer(
  ({ data, containerStyles, containerClassName, is_xirr }) => {
    const [percentWidth, setPercentWidth] = useState(50);
    const [creditWidth, setCreditWidth] = useState(50);
    const [maxPercent, setMaxPercent] = useState(0);

    useEffect(() => {
      let maxWidth = 0;
      let maxPercentage = 0;
      data.forEach((item) => {
        const tempSpan = document.createElement("span");
        tempSpan.innerText = `${item?.current_value?.value} ${displayUnit(
          item?.current_value?.value_type
        )}`;

        tempSpan.style.visibility = "hidden";
        document.body.appendChild(tempSpan);

        const spanWidth = tempSpan.offsetWidth;
        if (spanWidth > maxWidth) maxWidth = spanWidth;

        document.body.removeChild(tempSpan);

        const fillPercent = Math.abs(
          is_xirr === "irr"
            ? item?.investmentPerformance?.return_percentage
            : item?.abs_val
        );
        if (fillPercent > maxPercentage) maxPercentage = fillPercent;
      });

      if (creditWidth < maxWidth) {
        setCreditWidth(maxWidth);
      }
      if (maxPercentage > maxPercent) setMaxPercent(maxPercentage);
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      let maxWidth = 0;
      data.forEach((text) => {
        const tempSpan = document.createElement("span");
        const per =
          is_xirr === "irr"
            ? text?.investmentPerformance?.return_percentage
            : text?.abs_val;
        tempSpan.innerText = `${per > 9999.99 ? 9999.99 : per}%`;

        tempSpan.style.visibility = "hidden";
        document.body.appendChild(tempSpan);

        const spanWidth = tempSpan.offsetWidth;
        if (spanWidth > maxWidth) {
          maxWidth = spanWidth;
        }

        document.body.removeChild(tempSpan);
      });

      if (creditWidth < maxWidth) setPercentWidth(maxWidth);
      // eslint-disable-next-line
    }, []);

    return (
      <div
        className={`container ${containerClassName}`}
        style={containerStyles}
      >
        {data?.map((item, index) => (
          <Bar
            item={item}
            index={index}
            is_xirr={is_xirr}
            percentWidth={percentWidth}
            creditWidth={creditWidth}
            maxPercent={maxPercent}
          />
        ))}
      </div>
    );
  }
);

export default BarChart;
